<div class="box-video-recording" style="cursor: pointer">
    <div class="image-recording algin-center w-100">
        <h2 class="font-bold" style="color:#000000">Are you sure you want to delete <br/> this simulation?</h2>
    </div>
    <button class="btn-yes-recording font-bold btn-common-style" (click)="onDeleteFeedBack()"> Yes, I delete feedback</button>
    <button mat-button class="btn-no-recording font-bold" [mat-dialog-close]="true">No, I don’t want to delete</button>
</div>
